import BaseNodeChildren from 'publisher/components/ChildrenEntities'
import StyleWrapper from 'publisher/components/core/StyleWrapper'
import { pageSelectors, usePage } from 'publisher/store'
import React, { MouseEvent, useState } from 'react'
import { CommonFaq } from 'src/shared/components/faq'
import { FaqItem } from 'src/shared/components/faq/faq-item'
import {
  FaqInterface,
  FaqItemInterface,
} from 'src/shared/entities/faq/faq.schema'

export const Faq = ({ entity }: { entity: FaqInterface }) => {
  const [activeIndexes, setActiveIndexes] = useState<Record<number, boolean>>(
    {},
  )
  const faqItems = usePage(page =>
    pageSelectors.getChildrenEntities(page, entity.childIds),
  ) as FaqItemInterface[]

  const toggleCollapse = (index: number) => (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()

    setActiveIndexes(prevIndexes => ({
      ...prevIndexes,
      [index]: !prevIndexes[index],
    }))
  }

  return (
    <StyleWrapper
      appearance={entity.appearance}
      margin={entity.margin}
      mobileMargin={entity.mobileMargin}
    >
      <CommonFaq
        mobilePadding={entity.mobilePadding}
        padding={entity.padding}
        htmlAttrId={entity.htmlAttrId}
        spaceBetweenItems={entity.spaceBetweenItems}
      >
        {faqItems.map((faqItem, index) => (
          <FaqItem
            key={faqItem.id}
            showIcons={entity.showIcons}
            mobileShowIcons={entity.mobileShowIcons}
            itemBorderRadius={entity.itemBorderRadius}
            itemPadding={entity.itemPadding}
            mobileItemPadding={entity.mobileItemPadding}
            backgroundColor={entity.backgroundColor}
            mobileBackgroundColor={entity.mobileBackgroundColor}
            titleColor={entity.titleColor}
            mobileTitleColor={entity.mobileTitleColor}
            titleFontSize={entity.titleFontSize}
            mobileTitleFontSize={entity.mobileTitleFontSize}
            titleFontFamily={entity.titleFontFamily}
            titleFontStyle={entity.titleFontStyle}
            titleFontWeight={entity.titleFontWeight}
            fontFileId={entity.fontFileId}
            mobileTitleFontFamily={entity.mobileTitleFontFamily}
            mobileTitleFontStyle={entity.mobileTitleFontStyle}
            mobileTitleFontWeight={entity.mobileTitleFontWeight}
            mobileFontFileId={entity.mobileFontFileId}
            title={faqItem.title}
            iconClassName={entity.iconClassName}
            closedIconClassName={entity.closedIconClassName}
            iconColor={entity.iconColor}
            mobileIconColor={entity.mobileIconColor}
            boxShadow={entity.boxShadow}
            mobileBoxShadow={entity.mobileBoxShadow}
            toggleCollapse={toggleCollapse(index)}
            expanded={activeIndexes[index]}
          >
            <BaseNodeChildren childIds={faqItem.childIds} />
          </FaqItem>
        ))}
      </CommonFaq>
    </StyleWrapper>
  )
}
